
export const updateLogin = (type, value) => dispatch => {
    dispatch(
        {
            type: type,
            payload : value
        }
    );      
}
